import React, { useEffect, useState } from "react";
import { api } from "@/lib/http";

// Timely-style "Any service / Selected services" rule with a chip picker. value = [] means any.
export const ServiceRule = ({ label, value, onChange, testid }) => {
  const [services, setServices] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/services").then(({ data }) => setServices((data || []).filter((s) => s.active !== false))).catch(() => {}); }, []);
  const sel = new Set(value || []);
  const toggle = (id) => { const n = new Set(sel); n.has(id) ? n.delete(id) : n.add(id); onChange([...n]); };
  const mode = sel.size ? "selected" : "any";
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <div className="text-sm font-medium">{label}</div>
      <div className="flex flex-wrap items-center gap-4 text-sm">
        <label className="inline-flex items-center gap-1.5 cursor-pointer"><input type="radio" checked={mode === "any"} onChange={() => { onChange([]); setOpen(false); }} data-testid={`${testid}-any`} />Any service</label>
        <label className="inline-flex items-center gap-1.5 cursor-pointer"><input type="radio" checked={mode === "selected"} onChange={() => setOpen(true)} data-testid={`${testid}-selected`} />Selected services{sel.size ? <span className="text-muted-foreground italic">({sel.size} selected)</span> : null}</label>
        {(mode === "selected" || open) && <button type="button" onClick={() => setOpen((v) => !v)} className="text-primary underline text-xs" data-testid={`${testid}-change`}>{open ? "Done" : "View / Change"}</button>}
      </div>
      {open && (
        <div className="flex flex-wrap gap-1.5 rounded-lg border p-2 bg-background max-h-40 overflow-auto" data-testid={`${testid}-picker`}>
          {services.map((s) => (
            <button key={s.id} type="button" onClick={() => toggle(s.id)} data-testid={`${testid}-svc-${s.id}`}
              className={`px-2.5 h-7 rounded-full text-xs border transition-colors ${sel.has(s.id) ? "bg-primary text-primary-foreground border-primary" : "border-border text-muted-foreground hover:bg-muted"}`}>{s.name}</button>
          ))}
          {services.length === 0 && <span className="text-xs text-muted-foreground">No services yet</span>}
        </div>
      )}
    </div>
  );
};
